// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C6VNt","badges":"styles_badges__2u6oL"};